import * as ActionTypes from '../actions';
import * as DownloadTypes from '../actions/download';
import { set, unset } from 'lodash';
import produce from 'immer';

const defaultDownloadState = { isDownloading: false, id: 0 };
const defaultState = { player: null, survey: {}, download: defaultDownloadState};

const posts = (state = defaultState, action) =>
  produce(state, draft => {
    /* eslint-disable default-case */
    switch (action.type) {
      case ActionTypes.ANSWER_UPDATE_RECEIVE:
        set(draft, `survey.entities.answers[${action.payload.id}]`, action.payload);
        return;
      case ActionTypes.ANSWER_CREATE_RECEIVE:
        set(draft, `survey.entities.answers[${action.payload.id}]`, action.payload);
        set(draft, `survey.entities.responseTypes[${action.payload.asqResponseTypeId}].answer`, action.payload.id);
        return;
      case ActionTypes.ANSWER_DELETE_RECEIVE:
        set(draft, `survey.entities.responseTypes[${action.meta.asqResponseTypeId}].answer`, null);
        unset(draft, `survey.entities.answers[${action.meta.id}]`);
        return;
      case ActionTypes.START_SURVEY_RECEIVE:
        draft.survey = action.payload;
        return;
      case ActionTypes.PLAYER_RECEIVE:
        draft.player = action.payload;
        return;
      case DownloadTypes.ASQ_REPORT_REQUEST:
        return {...state, download: { isDownloading: true, id: action.meta.id } };
      case DownloadTypes.ASQ_REPORT_RECEIVE:
        return {...state, download: defaultDownloadState };
      case ActionTypes.SURVEY_UPDATE_RECEIVE:
        draft.survey.entities.surveys[action.payload.id].status = 'finished';
        draft.survey.entities.surveys[action.payload.id].asqJid = action.payload.asqJid;
        return;
    }
  })

export default posts;
